import React, { useEffect, useState } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import './Detail.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faExternalLinkAlt, faHeart, } from '@fortawesome/free-solid-svg-icons'
import baseURL from '../../Components/url'
import Dias from '../../Components/Dias/Dias'

import { useMediaQuery } from '@react-hook/media-query';



export default function TallerDetail() {
    const { idTaller } = useParams()
    const navigate = useNavigate()
    const location = useLocation();
    const [taller, setTaller] = useState(null)
    const [loading, setLoading] = useState(true)
    const [favoritos, setFavoritos] = useState([]);

    const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);

    const toggleDescriptionExpanded = () => {
        setIsDescriptionExpanded(!isDescriptionExpanded);
    };

    const isScreenLarge = useMediaQuery('(min-width: 1024px)');

    useEffect(() => {
        const cargarTaller = async () => {
            try {
                const response = await fetch(`${baseURL}/talleresListadoGet.php?idTaller=${idTaller}`)
                const data = await response.json()
                // Filtrar el taller específico
                const tallerEncontrado = data.find(t => String(t.idTaller) === String(idTaller));

                if (tallerEncontrado) {
                    setTaller(tallerEncontrado);
                } else {
                    console.error('No se encontró el taller con el ID especificado');
                }
                setLoading(false)
            } catch (error) {
                console.error('Error al cargar el taller:', error)
                setLoading(false)
            }
        }

        cargarTaller()
    }, [idTaller])

    if (loading) {
        return <div className="loading">Cargando taller...</div>
    }

    if (!taller) {
        return <div className="not-found">Taller no encontrado</div>
    }

    const goBack = () => {
        location.key !== 'default' ? navigate(-1) : navigate('/');
    };

    const agregarAFavoritos = (idServicio) => {
        const favList = [...favoritos];
        const index = favList.indexOf(idServicio);
        if (index === -1) {
            favList.push(idServicio);
            setFavoritos(favList);
            localStorage.setItem('favoritos', JSON.stringify(favList));
        } else {
            favList.splice(index, 1);
            setFavoritos(favList);
            localStorage.setItem('favoritos', JSON.stringify(favList));
        }
    };

    const handleCompartirClick = () => {
        if (navigator.share) {
            navigator.share({
                title: document.title,
                text: 'Echa un vistazo a este servicio',
                url: window.location.href,
            }).then(() => {
                // Contenido compartido correctamente
            })
                .catch(error => console.error('Error al compartir:', error));
        } else {
            console.error('La API de compartir no está disponible en este navegador.');
        }
    };

    return (
        <div className="pageDetail">
            <div className="detail">
                <div className={`deFlexDetail `}>
                    <button className="back" onClick={goBack}> <FontAwesomeIcon icon={faArrowLeft} /> </button>
                    <div className="deFLexIcon">
                        <button onClick={() => agregarAFavoritos(idTaller)} className='favoritos-btn'>
                            <FontAwesomeIcon icon={faHeart} style={{ color: favoritos.includes(idTaller) ? '#06b5b8' : 'gray' }} />
                        </button>
                        <button className="share" onClick={handleCompartirClick}> <FontAwesomeIcon icon={faExternalLinkAlt} /> </button>
                    </div>
                </div>

                <div className="detail-contain">
                    <div className="imgContain">
                        {taller.imagen1 && (
                            <img
                                src={taller.imagen1}
                                alt={taller.nombre}
                                className="imagen1"
                            />
                        )}
                    </div>
                </div>

                <div className="textDetail">
                    <h2 className="title">{taller.nombre}</h2>
                    {isScreenLarge ? (
                        <span>
                            {taller.descripcion}
                        </span>
                    ) : (
                        <span onClick={toggleDescriptionExpanded} className="description-span">
                            {isDescriptionExpanded
                                ? taller.descripcion
                                : taller.descripcion.length > 80
                                    ? `${taller.descripcion.substring(0, 80)}...`
                                    : taller.descripcion
                            }
                            {taller.descripcion.length > 80 && (
                                <span className="view-more-btn">
                                    {isDescriptionExpanded ? " Ver menos" : " Ver más"}
                                </span>
                            )}
                        </span>
                    )}
                </div>

                {/* Sección de agendado */}
                <div className="scheduling-section">
                    <Dias
                        idServicio={taller.idTaller}
                        tipoRecurso="taller"
                        servicio={taller.nombre.replace(/\s+/g, '-').toLowerCase()}
                        categoria={taller.nombre_ceseco}
                        ubicacionTienda={taller.mapaUrlTienda}
                        cupoMax={taller.cupoMax}
                    />
                </div>
            </div>
        </div >
    )
}
